export class ProfileStatistics {
  public followers: number;
  public following: number;
}
